export default "__VITE_ASSET__CEH3NU71__"